import { FleekError } from './FleekError';

type Framework = {
  id?: string;
  name?: string;
};
type SiteFrameworkNotFoundErrorOptions = {
  framework: Framework;
};

export class SiteFrameworkNotFoundError extends FleekError<SiteFrameworkNotFoundErrorOptions> {
  public name = 'SiteFrameworkNotFoundError';

  toString = () => `Site framework not found.`;
}
